import { render } from "./Login.vue?vue&type=template&id=31318d27&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=31318d27&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-31318d27"

export default script